<div class="modal-header">
	@if (showModalClose()) {
	<button class="close" (click)="modalRef.hide()">&times;</button>
	}
	<h4 class="modal-title">Add Company</h4>
</div>
<div class="modal-body">
	@if (errorMessage()) {
	<div class="alert alert-danger manual-add-submit-error">
		{{ errorMessage() }}
	</div>
	}
	<app-stepper #stepper>
		<app-step tag="upload">
			<div class="manual-add-upload">
				<label class="control-label cor15-upload-heading">Upload COR15.1A (MOI)</label>
				<alert type="info">
					<span>Please upload a clear scanned copy of the COR15.1A (max 8MB).</span>
				</alert>

				@if (uploadError()) {
				<alert type="danger">{{ uploadError() }}</alert>
				}

				<app-upload-documents-form
					[autoSubmit]="false"
					accept=".pdf"
					(filesChanged)="onCorFilesChanged($event)"
					(rejectedFiles)="onCorFilesRejected($event)"
				>
					<p class="cta-text quick-add-trust-upload-note d-flex align-items-center justify-content-center gap-1">
						<app-icon [icon]="faLockIcon" class="quick-add-trust-upload-note__lock" />
						All files are securely stored in the documents tab.
					</p>
				</app-upload-documents-form>

				<div class="cor15-or-divider">
					<span>or</span>
				</div>
				<p class="text-center cor15-manual-capture">
					<a class="cor15-manual-capture-link" (click)="showManualForm()">Manually capture the information</a>
				</p>

				<div class="modal-footer">
					<app-submit-button
						submitLabel="Upload"
						[isDisabled]="!cor151AFile() || isExtracting()"
						[isBusy]="isExtracting()"
						(clicked)="submitCorUpload()"
					/>
				</div>
			</div>
		</app-step>

		<app-step tag="companyInformation" [stepControls]="companyForms()">
			<app-portfolio-company-details-form
					[isForeignCompany]="isForeignCompany()"
					[companyTypeId]="companyDetailsForm.get('company_type_id')?.value"
					[optionalContact]="true">
				<ng-container [formGroup]="companyDetailsForm">
					<!-- COMPANY NAME -->
					<div class="form-group required">
						<label class="control-label">Company Name</label>
						<input type="text" class="form-control" formControlName="company_name" placeholder="e.g. ALPHABET" />
						@if (companyDetailsForm | shouldShowError : 'company_name') {
						<span class="invalid-feedback">Please avoid name extensions such as "PTY" or "CC".</span>
						}

						<!-- COMPANY TYPE -->
						<select class="form-control" formControlName="company_type_id">
							@for (type of companyTypes; track type.id) {
							<option [value]="type.id" [text]="type.name"></option>
							}
						</select>
					</div>

					<div class="form-group required">
						<label class="control-label">Registration Number</label>
						<input
							type="text"
							class="form-control"
							formControlName="registration_number"
							placeholder="e.g. YYYY/123456/07"
						/>
					</div>

					<!-- TAX NUMBER -->
					<div class="form-group">
						<label class="control-label">Income Tax Number</label>
						<input type="text" class="form-control" formControlName="tax_number" placeholder="e.g. 9876543210" />
						@if (companyDetailsForm | shouldShowError : 'tax_number') {
						<span class="invalid-feedback">Please enter a valid tax number.</span>
						}
					</div>

					<div class="form-group required">
						<label class="control-label">Incorporation Date</label>
						<app-date-selector
							formControlName="incorporation_date"
							style="margin-top: 12px"
							[maxDate]="today"
							hideToday
						/>
					</div>
				</ng-container>
			</app-portfolio-company-details-form>

			<div class="modal-footer">
				<a class="btn-nav btn-prev" (click)="goBack()"> Back </a>
				<app-submit-button [isDisabled]="!isCompanyFormsValid()" submitLabel="Next" (clicked)="stepper.next()" />
			</div>
		</app-step>

		<app-step [stepControls]="directorStepControls()" tag="directorInformation">
			<app-directors-information
				[directorsHasOwnership]="false"
				[optionalContact]="true"
			/>

			<div class="modal-footer">
				<a class="btn-nav btn-prev" (click)="stepper.previous()"> Back </a>
				<app-submit-button [isDisabled]="!areDirectorsFormsValid()" submitLabel="Review" (clicked)="stepper.next()" />
			</div>
		</app-step>

		<app-step tag="reviewInformation">
			@if (stepper.selectedTag() === 'reviewInformation') {
			<app-company-information-confirmation
				[companyDetails]="getCompanyDetails()"
				[directorsDetails]="directorsDetailsForReview()"
			/>
			}

			<div class="modal-footer">
				<a class="btn-nav btn-prev" (click)="stepper.previous()"> Back </a>
				<app-submit-button
					class="manual-add-confirm"
					submitLabel="Confirm"
					(clicked)="submitCompanyRegistrationForm()"
					[isBusy]="isBusy()"
					[isDisabled]="isDuplicateRegistration()"
				/>
			</div>
		</app-step>

		<app-step tag="companyLimit">
			<app-company-limit-notice />

			<div class="modal-footer">
				<a class="btn-nav btn-prev company-limit-back" (click)="goBack()"> Back </a>
				<button class="btn btn-primary" (click)="modalRef.hide()">Close</button>
			</div>
		</app-step>

		<app-step tag="success">
			<div class="confirmation-dialog company-setup">
				<p class="text-center">Congratulations! Your company has been added.</p>
				@if (documentPersistError()) {
				<alert type="danger">{{ documentPersistError() }}</alert>
				}
				<img src="./assets/img/company-success.png" style="width: 75%" alt="Company Success" />
			</div>

			<div class="modal-footer">
				<app-submit-button submitLabel="View Company" (clicked)="goToDashboard()" />
			</div>
		</app-step>
	</app-stepper>
</div>
